import { computed } from '@ember/object';
import Enum from '@square/dashboard-utilities/utils/enum';
import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export const DurationUnit = new Enum(['DO_NOT_USE', 'DAY', 'MONTH', 'YEAR']);
export default ProtoBaseModel.extend({
  unit: attr(DurationUnit),
  count: attr(Number),
  isValid: computed('unit', function () {
    return DurationUnit.hasValue(this.unit) && this.unit !== DurationUnit.DO_NOT_USE;
  })
});